/**
 * ShopRole Model (RBAC Definition)
 * 
 * Defines the available roles and their associated capabilities (permissions).
 * Used for frontend validation and backend RLS policy generation.
 */

export const SHOP_ROLES = [
    {
        role: 'Owner',
        capabilities: ['*'], // Super admin access within the shop scope
        description: 'Full access to all shop settings, team management, and billing.'
    },
    {
        role: 'Manager',
        capabilities: [
            'manage_team',       // Can invite/remove staff (except owners)
            'manage_content',    // Can edit sites, logs, etc.
            'edit_shop_profile', // Can edit shop profile details
        ],
        description: 'Can manage team operations and content, but cannot delete the shop.'
    },
    {
        role: 'Staff',
        capabilities: [
            'manage_content',        // Can log dives, edit site details (if allowed)
            'view_basic_analytics'   // View basic traffic stats
        ],
        description: 'Can contribute content and view basic operational data.'
    }
];

export const getRoleCapabilities = (roleName) => {
    const role = SHOP_ROLES.find(r => r.role === roleName);
    return role ? role.capabilities : [];
};

export const isValidRole = (roleName) => {
    return SHOP_ROLES.some(r => r.role === roleName);
};
